import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "space-y-4 sm:space-y-6" }
const _hoisted_2 = { class: "bg-dark-secondary shadow rounded-lg p-4 sm:p-6" }
const _hoisted_3 = { class: "md:grid md:grid-cols-3 md:gap-6" }
const _hoisted_4 = { class: "md:col-span-1" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = { class: "relative flex h-2 w-2" }
const _hoisted_7 = { class: "mt-5 md:mt-0 md:col-span-2" }
const _hoisted_8 = { class: "space-y-4" }
const _hoisted_9 = { class: "space-y-3" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }
const _hoisted_12 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }
const _hoisted_13 = { class: "pt-4" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "flex items-center justify-center space-x-2" }
const _hoisted_16 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_17 = {
  key: 0,
  class: "mt-2 text-sm text-emerald-500"
}
const _hoisted_18 = { class: "pt-4 border-t border-gray-700 mt-4" }
const _hoisted_19 = { class: "relative group inline-block" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  width: "30",
  height: "30",
  viewBox: "0 0 50 50",
  style: {"fill":"#FFFFFF"}
}
const _hoisted_22 = {
  key: 0,
  class: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10 pointer-events-none"
}
const _hoisted_23 = { class: "bg-dark-secondary shadow rounded-lg p-4 sm:p-6" }
const _hoisted_24 = { class: "md:grid md:grid-cols-3 md:gap-6" }
const _hoisted_25 = { class: "mt-5 md:mt-0 md:col-span-2" }
const _hoisted_26 = { class: "space-y-4" }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "pt-4" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "flex items-center justify-center space-x-2" }
const _hoisted_32 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_33 = {
  key: 0,
  class: "mt-2 text-sm text-emerald-500"
}
const _hoisted_34 = { class: "bg-dark-secondary shadow rounded-lg p-4 sm:p-6" }
const _hoisted_35 = { class: "md:grid md:grid-cols-3 md:gap-6" }
const _hoisted_36 = { class: "mt-5 md:mt-0 md:col-span-2" }
const _hoisted_37 = { class: "space-y-4" }
const _hoisted_38 = { class: "pt-4" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "flex items-center justify-center space-x-2" }
const _hoisted_41 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_42 = {
  key: 0,
  class: "mt-2 text-sm text-emerald-500"
}
const _hoisted_43 = { class: "bg-dark-secondary shadow rounded-lg p-4 sm:p-6" }
const _hoisted_44 = { class: "md:grid md:grid-cols-3 md:gap-6" }
const _hoisted_45 = { class: "mt-5 md:mt-0 md:col-span-2" }
const _hoisted_46 = { class: "space-y-4" }
const _hoisted_47 = { class: "mb-8" }
const _hoisted_48 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_49 = {
  key: 1,
  class: "text-sm text-red-500"
}
const _hoisted_50 = {
  key: 2,
  class: "text-sm text-gray-400"
}
const _hoisted_51 = {
  key: 3,
  class: "space-y-3"
}
const _hoisted_52 = { class: "flex items-center justify-between" }
const _hoisted_53 = { class: "flex items-center space-x-3" }
const _hoisted_54 = { class: "font-mono text-gray-300" }
const _hoisted_55 = { class: "text-xs text-gray-500" }
const _hoisted_56 = { class: "flex gap-1" }
const _hoisted_57 = ["onClick", "disabled"]
const _hoisted_58 = {
  key: 0,
  class: "relative mb-6"
}
const _hoisted_59 = { class: "relative" }
const _hoisted_60 = ["value"]
const _hoisted_61 = ["stroke"]
const _hoisted_62 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 13l4 4L19 7"
}
const _hoisted_63 = {
  key: 1,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
}
const _hoisted_64 = { class: "pt-4" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { class: "flex items-center justify-center space-x-2" }
const _hoisted_67 = {
  key: 0,
  class: "mt-2 text-sm text-red-500"
}
const _hoisted_68 = { class: "space-y-4" }
const _hoisted_69 = { class: "bg-dark-secondary border border-gray-700 rounded-md p-3" }
const _hoisted_70 = { class: "flex items-center space-x-3" }
const _hoisted_71 = { class: "font-mono text-gray-300" }
const _hoisted_72 = { class: "text-xs text-gray-500" }
const _hoisted_73 = { class: "flex justify-end space-x-3" }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = { class: "bg-dark-secondary shadow rounded-lg p-4 sm:p-6" }
const _hoisted_76 = { class: "md:grid md:grid-cols-3 md:gap-6" }
const _hoisted_77 = { class: "mt-5 md:mt-0 md:col-span-2" }
const _hoisted_78 = { class: "space-y-4" }
const _hoisted_79 = { class: "relative" }
const _hoisted_80 = { class: "relative overflow-x-auto" }
const _hoisted_81 = { class: "bg-dark-secondary border border-gray-700 rounded-md text-gray-100 p-4 font-mono text-sm whitespace-pre-wrap break-all" }
const _hoisted_82 = { class: "text-emerald-300" }
const _hoisted_83 = ["stroke"]
const _hoisted_84 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 13l4 4L19 7"
}
const _hoisted_85 = {
  key: 1,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
}
const _hoisted_86 = { class: "relative" }
const _hoisted_87 = ["stroke"]
const _hoisted_88 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 13l4 4L19 7"
}
const _hoisted_89 = {
  key: 1,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
}

import { ref, onMounted, watch, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { db, auth } from '@/config/firebase'
import { doc, getDoc, updateDoc, onSnapshot, deleteDoc } from 'firebase/firestore'
import { useAuthStore } from '@/stores/auth'
import { functions } from '@/config/firebase'
import { httpsCallable } from 'firebase/functions'
import BaseModal from '@/components/ui/BaseModal.vue'

interface AIContext {
  businessDescription: string
}

interface OrgConfig {
  id: string
  created_at: Date
  updated_at: Date
  keys: {
    shopify?: {
      storeName: string
      apiKey: string
      secretKey: string
      accessToken: string
      clientId?: string
      clientSecret?: string
      isConnected: boolean
      lastSyncTime: string | null
    }
  }
  allowed_origins: string[]
  analysis_categories: string[]
  daily_insights: any[]
  prompt: string
  aiContext?: AIContext
}

interface APIKey {
  id: string
  last_four_chars: string
  created_at: Date
  scopes: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchSettingsView',
  setup(__props) {

const authStore = useAuthStore()
const route = useRoute()
const isConnected = ref(false)
const isRefreshing = ref(false)
const isSaving = ref(false)
const copySuccess = ref(false)
const copyConversionSuccess = ref(false)
const orgId = ref('')
const isSavingDomains = ref(false)
const isSavingAI = ref(false)
const lastSyncTime = ref<string | null>(null)
const allowedDomains = ref<string[]>([''])
const aiContext = ref<AIContext>({
  businessDescription: ''
})

const shopifyCredentials = ref({
  storeName: '',
  apiKey: '',
  secretKey: '',
  accessToken: '',
  clientId: '',
  clientSecret: ''
})

const saveSuccess = ref(false)
const saveDomainsSuccess = ref(false)
const saveAISuccess = ref(false)

let unsubscribeOrg: (() => void) | null = null

const copyInstallCode = async () => {
  try {
    const installCode = `<script src="https://api.searchplus.io/script.js"><\/script>
<script>
window.sp = new SearchPlus({ org_id: '${orgId.value}' });
<\/script>`
    await navigator.clipboard.writeText(installCode)
    copySuccess.value = true
    setTimeout(() => {
      copySuccess.value = false
    }, 2000)
  } catch (error) {
    console.error('Error copying to clipboard:', error)
  }
}

const copyConversionCode = async () => {
  try {
    const conversionCode = `analytics.subscribe("checkout_completed", function (event) {
  const search_id = event.data.checkout.attributes.search_plus_id;
  if(!search_id) return;
  const script = document.createElement('script');
  script.setAttribute('src', \`https://australia-southeast1-search-plus-3bf60.cloudfunctions.net/conversion?amount=\${event.data.checkout.totalPrice?.amount}&search_id=\${search_id}&order_id=\${event.data.checkout.order?.id}\`);
  script.setAttribute('async', '');
  document.head.appendChild(script);
});`
    await navigator.clipboard.writeText(conversionCode)
    copyConversionSuccess.value = true
    setTimeout(() => {
      copyConversionSuccess.value = false
    }, 2000)
  } catch (error) {
    console.error('Error copying conversion code to clipboard:', error)
  }
}

const loadSettings = async () => {
  try {
    // First get the user's document to get their org_id
    if (!auth.currentUser) return
    
    const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid))
    if (!userDoc.exists()) {
      console.error('User document not found')
      return
    }

    const userData = userDoc.data()
    orgId.value = userData.org_id
    if (!orgId.value) {
      console.error('No org_id found for user')
      return
    }

    // Set up real-time listener for the org document
    if (unsubscribeOrg) {
      unsubscribeOrg()
    }

    unsubscribeOrg = onSnapshot(doc(db, 'config', orgId.value), (orgDoc) => {
      if (!orgDoc.exists()) {
        console.error('Org document not found')
        return
      }

      const orgData = orgDoc.data() as OrgConfig
      
      // Set the component data from org config
      allowedDomains.value = orgData.allowed_origins || ['']
      aiContext.value = orgData.aiContext || {
          businessDescription: ''
        }

      // Set Shopify credentials if they exist
      if (orgData.keys?.shopify) {
        const shopifyKeys = orgData.keys.shopify
        shopifyCredentials.value = {
          storeName: shopifyKeys.storeName || '',
          apiKey: shopifyKeys.apiKey || '',
          secretKey: shopifyKeys.secretKey || '',
          accessToken: shopifyKeys.accessToken || '',
          clientId: shopifyKeys.clientId || '',
          clientSecret: shopifyKeys.clientSecret || ''
        }
        isConnected.value = shopifyKeys.isConnected || false
        lastSyncTime.value = shopifyKeys.lastSyncTime || null
      } else {
        // Reset values if Shopify keys don't exist
        shopifyCredentials.value = {
          storeName: '',
          apiKey: '',
          secretKey: '',
          accessToken: '',
          clientId: '',
          clientSecret: ''
        }
        isConnected.value = false
        lastSyncTime.value = null
      }
    }, (error) => {
      console.error('Error listening to org document:', error)
    })

  } catch (error) {
    console.error('Error loading settings:', error)
  }
}

const connectToShopify = () => {
  if (!shopifyCredentials.value.storeName) {
    alert('Please enter a store name')
    return
  }
  
  const storeName = shopifyCredentials.value.storeName.replace('.myshopify.com', '').replace('https://', '').replace('/', '')
  const functionUrl = `https://australia-southeast1-search-plus-3bf60.cloudfunctions.net/shopifyAuth`
  window.location.href = `${functionUrl}?shop=${storeName}.myshopify.com&org_id=${orgId.value}`
}

const saveSettings = async () => {
  if (!auth.currentUser) return
  isSaving.value = true
  saveSuccess.value = false
  
  try {
    const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid))
    if (!userDoc.exists()) return
    
    const orgIdValue = userDoc.data().org_id
    if (!orgIdValue) return

    await updateDoc(doc(db, 'config', orgIdValue), {
      'keys.shopify': {
        ...shopifyCredentials.value,
      isConnected: isConnected.value,
        lastSyncTime: lastSyncTime.value
      },
      updated_at: new Date()
    })
    
    // Show success state
    saveSuccess.value = true
    // Reset success state after 2 seconds
    setTimeout(() => {
      saveSuccess.value = false
    }, 2000)
  } catch (error) {
    console.error('Error saving settings:', error)
  } finally {
    isSaving.value = false
  }
}

const saveAllowedDomains = async () => {
  if (!auth.currentUser) return
  isSavingDomains.value = true
  saveDomainsSuccess.value = false
  
  try {
    const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid))
    if (!userDoc.exists()) return
    
    const orgIdValue = userDoc.data().org_id
    if (!orgIdValue) return

    await updateDoc(doc(db, 'config', orgIdValue), {
      allowed_origins: allowedDomains.value.filter(Boolean),
      updated_at: new Date()
    })
    
    // Show success state
    saveDomainsSuccess.value = true
    // Reset success state after 2 seconds
    setTimeout(() => {
      saveDomainsSuccess.value = false
    }, 2000)
  } catch (error) {
    console.error('Error saving allowed domains:', error)
  } finally {
    isSavingDomains.value = false
  }
}

const saveAIContext = async () => {
  if (!auth.currentUser) return
  isSavingAI.value = true
  saveAISuccess.value = false
  
  try {
    const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid))
    if (!userDoc.exists()) return
    
    const orgIdValue = userDoc.data().org_id
    if (!orgIdValue) return

    await updateDoc(doc(db, 'config', orgIdValue), {
      aiContext: aiContext.value,
      updated_at: new Date()
    })
    
    // Show success state
    saveAISuccess.value = true
    // Reset success state after 2 seconds
    setTimeout(() => {
      saveAISuccess.value = false
    }, 2000)
  } catch (error) {
    console.error('Error saving AI context:', error)
  } finally {
    isSavingAI.value = false
  }
}

const addDomain = () => {
  allowedDomains.value.push('')
}

const removeDomain = (index: number) => {
  allowedDomains.value.splice(index, 1)
}

const formatLastSync = (date: string | null) => {
  if (!date) return 'Never'
  const d = new Date(date)
  const now = new Date()
  const diff = now.getTime() - d.getTime()
  
  if (diff < 60000) return 'Just now'
  if (diff < 3600000) return `${Math.floor(diff / 60000)} minutes ago`
  if (diff < 86400000) return `${Math.floor(diff / 3600000)} hours ago`
  return `${Math.floor(diff / 86400000)} days ago`
}

const formatDate = (date: Date | any) => {
  if (!date) return ''
  const d = new Date(date)
  if (isNaN(d.getTime())) return 'Invalid Date'

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }).format(d)
}

const disconnectShopify = async () => {
  // Implement disconnect logic
  isConnected.value = false
  shopifyCredentials.value.accessToken = '' // Clear access token on disconnect
}

// API Key Management
const generatedApiKey = ref<string>('')
const isGeneratingKey = ref(false)
const apiKeyError = ref<string>('')
const copyApiKeySuccess = ref(false)
const existingKeys = ref<APIKey[]>([])
const isLoadingKeys = ref(false)
const loadKeysError = ref<string>('')
const isDeletingKey = ref<string | null>(null)
const showDeleteModal = ref(false)
const keyToDelete = ref<APIKey | null>(null)

const confirmDelete = (key: APIKey) => {
  keyToDelete.value = key
  showDeleteModal.value = true
}

const loadAPIKeys = async () => {
  if (!auth.currentUser) return
  isLoadingKeys.value = true
  loadKeysError.value = ''
  
  try {
    const getAPIKeys = httpsCallable(functions, 'getAPIKeys')
    const result = await getAPIKeys()
    const { success, api_keys } = (result.data as any)
    
    if (success && api_keys) {
      existingKeys.value = api_keys.map((key: any) => {
        let date = key.created_at
        // Handle Firestore timestamp objects
        if (date && typeof date === 'object' && (date._seconds || date.seconds)) {
          date = new Date((date._seconds || date.seconds) * 1000)
        } else {
          date = new Date(date)
        }
        return {
          ...key,
          created_at: date
        }
      })
    } else {
      throw new Error('Failed to load API keys')
    }
  } catch (error) {
    console.error('Error loading API keys:', error)
    loadKeysError.value = 'Failed to load API keys. Please try again.'
  } finally {
    isLoadingKeys.value = false
  }
}

const generateApiKey = async () => {
  if (!auth.currentUser) return
  isGeneratingKey.value = true
  apiKeyError.value = ''
  
  try {
    const createAPIKey = httpsCallable(functions, 'createAPIKey')
    const result = await createAPIKey()
    const { success, api_key } = result.data as { success: boolean; api_key: string; uid: string }
    
    if (success && api_key) {
      generatedApiKey.value = api_key
      // Reload the list of API keys
      await loadAPIKeys()
    } else {
      throw new Error('Failed to generate API key')
    }
  } catch (error) {
    console.error('Error generating API key:', error)
    apiKeyError.value = 'Failed to generate API key. Please try again.'
  } finally {
    isGeneratingKey.value = false
  }
}

const copyApiKey = async () => {
  try {
    await navigator.clipboard.writeText(generatedApiKey.value)
    copyApiKeySuccess.value = true
    setTimeout(() => {
      copyApiKeySuccess.value = false
    }, 2000)
  } catch (error) {
    console.error('Error copying API key to clipboard:', error)
    apiKeyError.value = 'Failed to copy API key. Please try copying manually.'
  }
}

const deleteAPIKey = async (keyId: string | undefined) => {
  if (!auth.currentUser || !keyId) return
  isDeletingKey.value = keyId
  
  try {
    await deleteDoc(doc(db, 'api-keys', keyId))
    // Remove the key from the local list
    existingKeys.value = existingKeys.value.filter(key => key.id !== keyId)
    // Close the modal
    showDeleteModal.value = false
    keyToDelete.value = null
  } catch (error) {
    console.error('Error deleting API key:', error)
    loadKeysError.value = 'Failed to delete API key. Please try again.'
  } finally {
    isDeletingKey.value = null
  }
}

onMounted(async () => {
  // Initialize auth store if not already done
  await authStore.init()
  
  // Wait for auth state to be loaded
  if (!authStore.loading && auth.currentUser) {
    await loadSettings()
    await loadAPIKeys()

    if (route.query.success === 'true') {
      saveSuccess.value = true
      setTimeout(() => {
        saveSuccess.value = false
      }, 5000)
    }
  }
})

// Add watcher for auth loading state
watch(
  () => authStore.loading,
  async (newLoading) => {
    if (!newLoading && auth.currentUser) {
      await loadSettings()
      await loadAPIKeys()
    }
  }
)

// Cleanup listener when component is unmounted
onUnmounted(() => {
  if (unsubscribeOrg) {
    unsubscribeOrg()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[45] || (_cache[45] = _createElementVNode("div", null, [
      _createElementVNode("h1", { class: "text-2xl font-semibold text-gray-100" }, "Integrations"),
      _createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Connect your store and configure search settings")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createStaticVNode("<h3 class=\"text-lg sm:text-xl font-medium text-gray-100\">Shopify Integration</h3><p class=\"mt-1 text-sm text-gray-400\"> Connect your Shopify store to enable AI-powered search </p><div class=\"mt-2 flex flex-wrap items-center text-xs text-gray-400\"><span class=\"font-mono text-gray-300\">read_orders</span><span class=\"mx-2\">•</span><span class=\"font-mono text-gray-300\">read_inventory</span><span class=\"mx-2\">•</span><span class=\"font-mono text-gray-300\">read_products</span></div>", 3)),
          _createElementVNode("div", {
            class: _normalizeClass(["mt-4 inline-flex items-center px-3 py-1.5 rounded-lg border", isConnected.value ? 'bg-emerald-500/10 border-emerald-500/20' : 'bg-yellow-500/10 border-yellow-500/20'])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("span", {
                  class: _normalizeClass(["animate-ping absolute inline-flex h-full w-full rounded-full opacity-75", isConnected.value ? 'bg-emerald-500' : 'bg-yellow-500'])
                }, null, 2),
                _createElementVNode("span", {
                  class: _normalizeClass(["relative inline-flex rounded-full h-2 w-2", isConnected.value ? 'bg-emerald-500' : 'bg-yellow-500'])
                }, null, 2)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm font-medium", isConnected.value ? 'text-emerald-500' : 'text-yellow-500'])
              }, _toDisplayString(isConnected.value ? 'Connected to Shopify' : 'Not Connected'), 3)
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Store Name", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shopifyCredentials.value.storeName) = $event)),
                    type: "text",
                    class: "flex-1 bg-dark-secondary border border-gray-700 rounded-l-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                    placeholder: "my-store"
                  }, null, 512), [
                    [_vModelText, shopifyCredentials.value.storeName]
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "bg-dark-secondary border border-l-0 border-gray-700 rounded-r-md px-3 py-2 text-gray-400" }, ".myshopify.com", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "API Key (Legacy)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shopifyCredentials.value.apiKey) = $event)),
                    type: "text",
                    class: "w-full bg-dark-secondary border border-gray-700 rounded-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                    placeholder: "Enter your Shopify API Key"
                  }, null, 512), [
                    [_vModelText, shopifyCredentials.value.apiKey]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Secret Key (Legacy)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shopifyCredentials.value.secretKey) = $event)),
                    type: "password",
                    class: "w-full bg-dark-secondary border border-gray-700 rounded-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                    placeholder: "Enter your Shopify Secret Key"
                  }, null, 512), [
                    [_vModelText, shopifyCredentials.value.secretKey]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", null, [
                  _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"flex items-center gap-1 mb-2\"><label class=\"text-sm font-medium text-gray-300\">Client ID</label><div class=\"relative group\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-4 w-4 text-gray-400 cursor-help\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg><div class=\"absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity z-10 pointer-events-none w-64 text-center\"> Request these credentials from your Search+ account manager <div class=\"absolute top-full left-1/2 transform -translate-x-1/2 -mt-1 border-4 border-transparent border-t-gray-900\"></div></div></div></div>", 1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shopifyCredentials.value.clientId) = $event)),
                    type: "text",
                    class: "w-full bg-dark-secondary border border-gray-700 rounded-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                    placeholder: "Enter your Client ID"
                  }, null, 512), [
                    [_vModelText, shopifyCredentials.value.clientId]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"flex items-center gap-1 mb-2\"><label class=\"text-sm font-medium text-gray-300\">Client Secret</label><div class=\"relative group\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-4 w-4 text-gray-400 cursor-help\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg><div class=\"absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity z-10 pointer-events-none w-64 text-center\"> Request these credentials from your Search+ account manager <div class=\"absolute top-full left-1/2 transform -translate-x-1/2 -mt-1 border-4 border-transparent border-t-gray-900\"></div></div></div></div>", 1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((shopifyCredentials.value.clientSecret) = $event)),
                    type: "password",
                    class: "w-full bg-dark-secondary border border-gray-700 rounded-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                    placeholder: "Enter your Client Secret"
                  }, null, 512), [
                    [_vModelText, shopifyCredentials.value.clientSecret]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Access Token", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shopifyCredentials.value.accessToken) = $event)),
                  type: "password",
                  class: "w-full bg-dark-secondary border border-gray-700 rounded-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                  placeholder: "Enter your Shopify Access Token"
                }, null, 512), [
                  [_vModelText, shopifyCredentials.value.accessToken]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                onClick: saveSettings,
                disabled: isSaving.value,
                class: _normalizeClass([
                  'w-full sm:w-auto px-4 py-2 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark transition-colors duration-200',
                  saveSuccess.value ? 'bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-500' : 'bg-primary hover:bg-primary-dark focus:ring-primary'
                ])
              }, [
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(isSaving.value ? 'Saving...' : 'Save Settings'), 1),
                  (saveSuccess.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[18] || (_cache[18] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M5 13l4 4L19 7"
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_14),
              (saveSuccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Settings saved!"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-300 mb-3" }, "Or connect automatically", -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  onClick: connectToShopify,
                  disabled: !shopifyCredentials.value.clientId || !shopifyCredentials.value.clientSecret,
                  class: _normalizeClass([
                    'w-full sm:w-auto px-4 py-2 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark transition-colors duration-200 flex items-center justify-center space-x-2',
                    (!shopifyCredentials.value.clientId || !shopifyCredentials.value.clientSecret) ? 'bg-gray-600 cursor-not-allowed opacity-50' : 'bg-[#64943e] hover:bg-[#64943e]'
                  ])
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_21, _cache[19] || (_cache[19] = [
                    _createElementVNode("path", { d: "M 22.839844 2.0351562 C 19.659152 1.9484924 16.325547 6.1910156 14.529297 12.720703 L 8.8847656 14.560547 C 8.5177656 14.680547 8.2511719 14.999812 8.2011719 15.382812 L 4.7558594 42.193359 C 4.6888594 42.718359 5.0415 43.204734 5.5625 43.302734 L 29.630859 47.882812 L 31.488281 7.1972656 L 30.376953 7.5585938 C 29.713953 5.1145938 28.473844 3.5775156 26.839844 3.2285156 C 26.344844 3.1205156 25.866344 3.1427656 25.402344 3.2597656 C 24.845344 2.6717656 24.203656 2.266375 23.472656 2.109375 C 23.262469 2.0645 23.05189 2.0409338 22.839844 2.0351562 z M 22.720703 4.0371094 C 22.835859 4.0344238 22.948953 4.0437813 23.056641 4.0664062 C 23.227641 4.1034062 23.392734 4.17925 23.552734 4.28125 C 21.567734 5.97825 20.050047 9.1985469 19.248047 11.185547 L 16.847656 11.966797 C 18.482656 6.9417969 20.993363 4.0773926 22.720703 4.0371094 z M 26.65625 5.2675781 C 27.42425 5.5845781 28.071563 6.6167344 28.476562 8.1777344 L 27.453125 8.5117188 C 27.293125 7.2737188 27.02925 6.1775781 26.65625 5.2675781 z M 24.755859 5.9179688 C 25.120859 6.7669688 25.386484 7.865625 25.521484 9.140625 L 21.791016 10.355469 C 22.804016 8.2054687 23.847859 6.7299688 24.755859 5.9179688 z M 33.482422 7.3964844 L 31.636719 47.806641 L 44.216797 45.023438 C 44.728797 44.910438 45.065234 44.421297 44.990234 43.904297 C 43.389234 32.807297 40.349922 11.701203 40.294922 11.283203 C 40.283922 11.183203 40.25875 11.085188 40.21875 10.992188 C 40.02275 10.542188 39.668313 10.219641 39.195312 10.056641 C 39.103313 10.025641 38.993484 10.007906 38.896484 10.003906 C 38.674484 9.9949062 36.702281 9.8413906 35.863281 9.7753906 C 35.177281 9.0743906 33.860578 7.7328281 33.517578 7.4238281 C 33.506578 7.4128281 33.493422 7.4064844 33.482422 7.3964844 z M 22.71875 18.023438 C 24.78275 18.023438 25.880734 18.672172 25.927734 18.701172 C 26.124734 18.820172 26.213578 19.06125 26.142578 19.28125 L 24.630859 23.941406 C 24.584859 24.083406 24.479797 24.196953 24.341797 24.251953 C 24.201797 24.309953 24.046016 24.298516 23.916016 24.228516 C 23.903016 24.221516 22.63025 23.539063 21.15625 23.539062 C 19.37325 23.539062 19.107422 24.451141 19.107422 24.994141 C 19.107422 25.583141 19.880344 26.166844 20.777344 26.839844 C 22.364344 28.031844 24.537109 29.663453 24.537109 32.939453 C 24.537109 37.043453 21.982219 39.912109 18.324219 39.912109 C 14.164219 39.912109 12.069422 37.320937 11.982422 37.210938 C 11.881422 37.083937 11.848531 36.913813 11.894531 36.757812 L 12.957031 33.185547 C 13.006031 33.022547 13.136781 32.894656 13.300781 32.847656 C 13.463781 32.803656 13.641531 32.840172 13.769531 32.951172 C 13.789531 32.969172 15.726719 34.662109 17.261719 34.662109 C 18.154719 34.662109 18.390625 33.946359 18.390625 33.568359 C 18.390625 32.588359 17.673625 31.991328 16.765625 31.236328 C 15.511625 30.194328 13.953125 28.897031 13.953125 26.082031 C 13.953125 22.201031 16.658609 18.025391 22.599609 18.025391 C 22.639609 18.025391 22.67875 18.023438 22.71875 18.023438 z" }, null, -1)
                  ]))),
                  _cache[20] || (_cache[20] = _createElementVNode("span", null, "Connect to Shopify", -1))
                ], 10, _hoisted_20),
                (!shopifyCredentials.value.clientId || !shopifyCredentials.value.clientSecret)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[21] || (_cache[21] = [
                      _createTextVNode(" Enter Client ID and Client Secret to connect "),
                      _createElementVNode("div", { class: "absolute top-full left-1/2 transform -translate-x-1/2 -mt-1 border-4 border-transparent border-t-gray-900" }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "md:col-span-1" }, [
          _createElementVNode("h3", { class: "text-lg sm:text-xl font-medium text-gray-100" }, "Allowed Domains"),
          _createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, " Configure which domains can use your search widget ")
        ], -1)),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowedDomains.value, (domain, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "flex items-center space-x-2"
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((allowedDomains.value[index]) = $event),
                  type: "text",
                  class: "flex-1 bg-dark-secondary border border-gray-700 rounded-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                  placeholder: "*.example.com"
                }, null, 8, _hoisted_27), [
                  [_vModelText, allowedDomains.value[index]]
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeDomain(index)),
                  class: "p-2 text-gray-400 hover:text-gray-300"
                }, _cache[23] || (_cache[23] = [
                  _createElementVNode("svg", {
                    class: "w-5 h-5",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]), 8, _hoisted_28)
              ]))
            }), 128)),
            _createElementVNode("button", {
              onClick: addDomain,
              class: "text-sm text-primary hover:text-primary-dark flex items-center space-x-1"
            }, _cache[24] || (_cache[24] = [
              _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 4v16m8-8H4"
                })
              ], -1),
              _createElementVNode("span", null, "Add Domain", -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              onClick: saveAllowedDomains,
              disabled: isSavingDomains.value,
              class: _normalizeClass([
                'w-full sm:w-auto px-4 py-2 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark transition-colors duration-200',
                saveDomainsSuccess.value ? 'bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-500' : 'bg-primary hover:bg-primary-dark focus:ring-primary'
              ])
            }, [
              _createElementVNode("span", _hoisted_31, [
                _createElementVNode("span", null, _toDisplayString(isSavingDomains.value ? 'Saving...' : 'Save Domains'), 1),
                (saveDomainsSuccess.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _cache[25] || (_cache[25] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M5 13l4 4L19 7"
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_30),
            (saveDomainsSuccess.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Domains saved!"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "md:col-span-1" }, [
          _createElementVNode("h3", { class: "text-lg sm:text-xl font-medium text-gray-100" }, "AI Context"),
          _createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, " Help the AI understand your business context ")
        ], -1)),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", null, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Business Description", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((aiContext.value.businessDescription) = $event)),
                rows: "3",
                class: "w-full bg-dark-secondary border border-gray-700 rounded-md text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
                placeholder: "Describe your business, products, and target customers..."
              }, null, 512), [
                [_vModelText, aiContext.value.businessDescription]
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                onClick: saveAIContext,
                disabled: isSavingAI.value,
                class: _normalizeClass([
                  'w-full sm:w-auto px-4 py-2 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark transition-colors duration-200',
                  saveAISuccess.value ? 'bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-500' : 'bg-primary hover:bg-primary-dark focus:ring-primary'
                ])
              }, [
                _createElementVNode("span", _hoisted_40, [
                  _createElementVNode("span", null, _toDisplayString(isSavingAI.value ? 'Saving...' : 'Save AI Context'), 1),
                  (saveAISuccess.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_41, _cache[28] || (_cache[28] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M5 13l4 4L19 7"
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_39),
              (saveAISuccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, "AI Context saved!"))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "md:col-span-1" }, [
          _createElementVNode("h3", { class: "text-lg sm:text-xl font-medium text-gray-100" }, "API Keys"),
          _createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, " Generate API keys to access Search Plus programmatically ")
        ], -1)),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _cache[31] || (_cache[31] = _createElementVNode("h4", { class: "text-base font-medium text-gray-100 mb-4" }, "Existing API Keys", -1)),
              (isLoadingKeys.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Loading API keys... "))
                : (loadKeysError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(loadKeysError.value), 1))
                  : (existingKeys.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, " No API keys found. Generate one using the button below. "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(existingKeys.value, (key) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: key.id,
                            class: "bg-dark-secondary border border-gray-700 rounded-md p-3"
                          }, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("span", _hoisted_54, "•••• " + _toDisplayString(key.last_four_chars), 1),
                                _createElementVNode("span", _hoisted_55, _toDisplayString(formatDate(key.created_at)), 1),
                                _createElementVNode("div", _hoisted_56, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(key.scopes, (scope) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: scope,
                                      class: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-700 text-gray-300"
                                    }, _toDisplayString(scope), 1))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (confirmDelete(key)),
                                disabled: isDeletingKey.value === key.id,
                                class: "text-gray-400 hover:text-red-400 transition-colors duration-200"
                              }, _cache[30] || (_cache[30] = [
                                _createElementVNode("svg", {
                                  class: "w-5 h-5",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                  })
                                ], -1)
                              ]), 8, _hoisted_57)
                            ])
                          ]))
                        }), 128))
                      ]))
            ]),
            (generatedApiKey.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Your New API Key", -1)),
                  _cache[33] || (_cache[33] = _createElementVNode("p", { class: "mb-1 text-sm text-yellow-400" }, " Copy this key now. You won't be able to see it again! ", -1)),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("input", {
                      type: "text",
                      readonly: "",
                      value: generatedApiKey.value,
                      class: "w-full bg-dark-secondary border border-gray-700 rounded-md text-gray-100 px-3 py-2 font-mono"
                    }, null, 8, _hoisted_60),
                    _createElementVNode("button", {
                      onClick: copyApiKey,
                      class: "absolute right-2 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-gray-300 focus:outline-none"
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: "w-5 h-5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: copyApiKeySuccess.value ? '#10B981' : 'currentColor'
                      }, [
                        (copyApiKeySuccess.value)
                          ? (_openBlock(), _createElementBlock("path", _hoisted_62))
                          : (_openBlock(), _createElementBlock("path", _hoisted_63))
                      ], 8, _hoisted_61))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("button", {
                onClick: generateApiKey,
                disabled: isGeneratingKey.value,
                class: "w-full sm:w-auto px-4 py-2 text-white bg-primary hover:bg-primary-dark rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark focus:ring-primary transition-colors duration-200"
              }, [
                _createElementVNode("span", _hoisted_66, [
                  _createElementVNode("span", null, _toDisplayString(isGeneratingKey.value ? 'Generating...' : 'Generate New API Key'), 1)
                ])
              ], 8, _hoisted_65),
              (apiKeyError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(apiKeyError.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(BaseModal, {
              modelValue: showDeleteModal.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showDeleteModal).value = $event))
            }, {
              title: _withCtx(() => _cache[34] || (_cache[34] = [
                _createTextVNode(" Delete API Key ")
              ])),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (showDeleteModal.value = false)),
                    class: "px-4 py-2 text-gray-300 hover:text-gray-100 transition-colors duration-200"
                  }, " Cancel "),
                  _createElementVNode("button", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (deleteAPIKey(keyToDelete.value?.id))),
                    disabled: isDeletingKey.value === keyToDelete.value?.id,
                    class: "px-4 py-2 text-white bg-red-600 hover:bg-red-700 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark focus:ring-red-500 transition-colors duration-200"
                  }, _toDisplayString(isDeletingKey.value === keyToDelete.value?.id ? 'Deleting...' : 'Delete Key'), 9, _hoisted_74)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_68, [
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "flex items-center text-yellow-400" }, [
                    _createElementVNode("svg", {
                      class: "w-5 h-5 mr-2",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                      })
                    ]),
                    _createElementVNode("span", { class: "font-medium" }, "Warning: This action cannot be undone")
                  ], -1)),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("span", _hoisted_71, "•••• " + _toDisplayString(keyToDelete.value?.last_four_chars), 1),
                      _createElementVNode("span", _hoisted_72, _toDisplayString(keyToDelete.value ? formatDate(keyToDelete.value.created_at) : ''), 1)
                    ])
                  ]),
                  _cache[36] || (_cache[36] = _createElementVNode("div", { class: "space-y-3 text-gray-300" }, [
                    _createElementVNode("p", null, "Deleting this API key will:"),
                    _createElementVNode("ul", { class: "list-disc list-inside space-y-2 ml-2" }, [
                      _createElementVNode("li", null, "Immediately invalidate the key"),
                      _createElementVNode("li", null, "Stop all API requests using this key"),
                      _createElementVNode("li", null, "Require updating any applications or services using this key"),
                      _createElementVNode("li", null, "Require generating a new key if access needs to be restored")
                    ])
                  ], -1))
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_75, [
      _createElementVNode("div", _hoisted_76, [
        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "md:col-span-1" }, [
          _createElementVNode("h3", { class: "text-lg sm:text-xl font-medium text-gray-100" }, "Installation")
        ], -1)),
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, "Header Tracking Script", -1)),
              _cache[42] || (_cache[42] = _createElementVNode("p", { class: "mb-1 text-sm text-gray-400" }, "Add this code to the header of your website to enable the search", -1)),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("pre", _hoisted_81, [
                  _createElementVNode("code", null, [
                    _cache[38] || (_cache[38] = _createStaticVNode("<span class=\"text-orange-400\">&lt;script</span> <span class=\"text-sky-300\">src</span>=<span class=\"text-emerald-300\">&quot;https://australia-southeast1-search-plus-3bf60.cloudfunctions.net/script&quot;</span><span class=\"text-orange-400\">&gt;&lt;/script&gt;</span>\n<span class=\"text-orange-400\">&lt;script&gt;</span><span class=\"text-gray-100\">window</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">sp</span> <span class=\"text-gray-400\">=</span> <span class=\"text-gray-100\">window</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">sp</span> <span class=\"text-gray-400\">||</span> <span class=\"text-purple-400\">new</span> <span class=\"text-yellow-300\">SearchPlus</span>({ <span class=\"text-sky-300\">org_id:</span> ", 26)),
                    _createElementVNode("span", _hoisted_82, "'" + _toDisplayString(orgId.value) + "'", 1),
                    _cache[39] || (_cache[39] = _createTextVNode(" });")),
                    _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-orange-400" }, "</script>", -1))
                  ])
                ])
              ]),
              _createElementVNode("button", {
                onClick: copyInstallCode,
                class: "absolute top-2 right-2 p-2 text-gray-400 hover:text-gray-300 focus:outline-none"
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  class: "w-5 h-5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: copySuccess.value ? '#10B981' : 'currentColor'
                }, [
                  (copySuccess.value)
                    ? (_openBlock(), _createElementBlock("path", _hoisted_84))
                    : (_openBlock(), _createElementBlock("path", _hoisted_85))
                ], 8, _hoisted_83))
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _cache[43] || (_cache[43] = _createStaticVNode("<label class=\"block text-sm font-medium text-gray-300 mb-2\">Conversion Tracking Script</label><p class=\"mb-1 text-sm text-gray-400\">Add this code to the customer events in shopify as a custom pixel</p><div class=\"relative overflow-x-auto\"><pre class=\"bg-dark-secondary border border-gray-700 rounded-md text-gray-100 p-4 font-mono text-sm whitespace-pre-wrap break-all\"><code><span class=\"text-gray-100\">analytics</span><span class=\"text-gray-400\">.</span><span class=\"text-yellow-300\">subscribe</span>(<span class=\"text-emerald-300\">&quot;checkout_completed&quot;</span>, <span class=\"text-purple-400\">function</span> (<span class=\"text-orange-300\">event</span>) {\n  <span class=\"text-purple-400\">const</span> <span class=\"text-sky-300\">search_id</span> <span class=\"text-gray-400\">=</span> <span class=\"text-gray-100\">event</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">data</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">checkout</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">attributes</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">search_plus_id</span>;\n  <span class=\"text-purple-400\">if</span>(<span class=\"text-gray-400\">!</span><span class=\"text-gray-100\">search_id</span>) <span class=\"text-purple-400\">return</span>;\n  <span class=\"text-purple-400\">const</span> <span class=\"text-sky-300\">script</span> <span class=\"text-gray-400\">=</span> <span class=\"text-gray-100\">document</span><span class=\"text-gray-400\">.</span><span class=\"text-yellow-300\">createElement</span>(<span class=\"text-emerald-300\">&#39;script&#39;</span>);\n  <span class=\"text-gray-100\">script</span><span class=\"text-gray-400\">.</span><span class=\"text-yellow-300\">setAttribute</span>(<span class=\"text-emerald-300\">&#39;src&#39;</span>, <span class=\"text-emerald-300\">`https://australia-southeast1-search-plus-3bf60.cloudfunctions.net/conversion?amount=${</span><span class=\"text-gray-100\">event</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">data</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">checkout</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">totalPrice</span><span class=\"text-gray-400\">?.</span><span class=\"text-gray-100\">amount</span><span class=\"text-emerald-300\">}&amp;search_id=${</span><span class=\"text-gray-100\">search_id</span><span class=\"text-emerald-300\">}&amp;order_id=${</span><span class=\"text-gray-100\">event</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">data</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">checkout</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">order</span><span class=\"text-gray-400\">?.</span><span class=\"text-gray-100\">id</span><span class=\"text-emerald-300\">}`</span>);\n  <span class=\"text-gray-100\">script</span><span class=\"text-gray-400\">.</span><span class=\"text-yellow-300\">setAttribute</span>(<span class=\"text-emerald-300\">&#39;async&#39;</span>, <span class=\"text-emerald-300\">&#39;&#39;</span>);\n  <span class=\"text-gray-100\">document</span><span class=\"text-gray-400\">.</span><span class=\"text-gray-100\">head</span><span class=\"text-gray-400\">.</span><span class=\"text-yellow-300\">appendChild</span>(<span class=\"text-gray-100\">script</span>);\n});</code></pre></div>", 3)),
              _createElementVNode("button", {
                onClick: copyConversionCode,
                class: "absolute top-2 right-2 p-2 text-gray-400 hover:text-gray-300 focus:outline-none"
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  class: "w-5 h-5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: copyConversionSuccess.value ? '#10B981' : 'currentColor'
                }, [
                  (copyConversionSuccess.value)
                    ? (_openBlock(), _createElementBlock("path", _hoisted_88))
                    : (_openBlock(), _createElementBlock("path", _hoisted_89))
                ], 8, _hoisted_87))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})